import { render } from "./OrganismsEconomy.vue?vue&type=template&id=193e303b&scoped=true&ts=true"
import script from "./OrganismsEconomy.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganismsEconomy.vue?vue&type=script&lang=ts&setup=true"

import "./OrganismsEconomy.vue?vue&type=style&index=0&id=193e303b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-193e303b"],['__file',"src/components/organisms/OrganismsEconomy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "193e303b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('193e303b', __exports__)) {
    api.reload('193e303b', __exports__)
  }
  
  module.hot.accept("./OrganismsEconomy.vue?vue&type=template&id=193e303b&scoped=true&ts=true", () => {
    api.rerender('193e303b', render)
  })

}


export default __exports__